module.exports = new __parcel__URL__("classic-calendar-skeleton.tpl.3dcfde16.svg").toString();